/* eslint-disabled no-unused-var */
import React, { useState, useRef, forwardRef, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import moment from 'moment';
import InputMask from 'react-input-mask';
import PropTypes from 'prop-types';
import DatePicker from 'react-datepicker';
import Alert from 'react-s-alert';

const formatDate = (date, def = '', format = 'YYYY-MM-DD') => {
  try {
    // const endDate = moment(date, 'MM/DD/YYYY HH:mm').format(format);
    const endDate = moment(date).format(format);

    if (_.isEmpty(date) && date === '') {
      return endDate === '';
    }

    if (endDate === 'Invalid date') {
      Alert.warning('Entered date is invalid');
    }

    const newDate = endDate === 'Invalid date' ? '' : endDate;

    return newDate;
  } catch (error) {
    return def;
  }
};

const CustomRender = forwardRef(({ onClick, btnClassName }, ref) => (
  <button
    type="button"
    ref={ref}
    className={`btn btn-primary  p-2 m-0 ${
      !_.isEmpty(btnClassName) ? btnClassName : 'button-date'
    }`}
    onClick={onClick}
  >
    <i
      className="fa fa-lg fa-calendar"
      style={{ marginTop: '5.5px', marginBottom: '5.5px' }}
    />
  </button>
));

CustomRender.propTypes = {
  onClick: PropTypes.instanceOf(Function),
  btnClassName: PropTypes.string,
};

CustomRender.defaultProps = {
  onClick: () => {},
  btnClassName: '',
};

const renderDateFormat = (showMonthYearPicker, withTime, showYearPicker) => {
  if (showMonthYearPicker) {
    return 'YYYY-MM';
  }
  if (withTime) {
    return 'MM/DD/YYYY HH:mm';
  }
  if (showYearPicker) {
    return 'YYYY';
  }
  return 'MM/DD/YYYY';
};

const inputMaskRenderFormat = (
  showMonthYearPicker,
  withTime,
  showYearPicker
) => {
  if (showMonthYearPicker) {
    return '9999-99';
  }
  if (withTime) {
    return '99/99/9999 99:99';
  }
  if (showYearPicker) {
    return '9999';
  }
  return '99/99/9999';
};

const renderPlaceHolder = (
  data,
  showMonthYearPicker,
  withTime,
  showYearPicker
) => {
  let placeHolder = '';
  if (data.length > 0) {
    return data;
  }

  placeHolder = () => {
    if (showMonthYearPicker) {
      return 'YYYY-MM';
    }
    if (withTime) {
      return 'MM/DD/YYYY HH:MM';
    }
    if (showYearPicker) {
      return 'YYYY';
    }
    return 'MM/DD/YYYY';
  };

  return placeHolder();
};

function DateInputPicker({
  disabled,
  showMonthYearPicker,
  withTime,
  showYearPicker,
  isRequired,
  placeholder,
  onChange,
  maxDate,
  minDate,
  value,
  openToDate,
  inputClassName,
  btnClassName,
  popperPlacement,
  name,
}) {
  const [selected, setSelected] = useState(new Date());
  const customRenderRef = useRef();

  const handleChangeInput = (e) => {
    setSelected(e.target.value);
  };

  const handleChangePicker = (e) => {
    const newVal = formatDate(
      e,
      '',
      renderDateFormat(showMonthYearPicker, withTime, showYearPicker)
    );
    onChange({ target: { value: newVal } });
  };

  const handleUpdateActual = (e) => {
    const newVal = formatDate(
      e.target.value,
      selected,
      renderDateFormat(showMonthYearPicker, withTime, showYearPicker)
    );
    if (new Date(newVal) < maxDate && new Date(newVal) >= minDate) {
      setSelected(newVal);
      onChange({ target: { value: newVal || '' } });
      return;
    }

    // setSelected('');
    onChange({ target: { value: newVal || '' } });
  };

  useEffect(() => {
    setSelected(value);
  }, [value]);

  return (
    <div className="input-group">
      <InputMask
        onChange={handleChangeInput}
        onBlur={handleUpdateActual}
        maskChar={null}
        disabled={disabled}
        required={isRequired}
        placeholder={renderPlaceHolder(
          placeholder,
          showMonthYearPicker,
          withTime,
          showYearPicker
        )}
        mask={inputMaskRenderFormat(
          showMonthYearPicker,
          withTime,
          showYearPicker
        )}
        className={`form-control ${inputClassName}`}
        value={selected || ''}
      />
      <div className="input-group-append">
        <DatePicker
          name={name}
          dateFormat="MM/dd/yyyy"
          customInput={
            <CustomRender ref={customRenderRef} btnClassName={btnClassName} />
          }
          disabled={disabled}
          showYearDropdown
          timeIntervals={15}
          showMonthYearPicker={showMonthYearPicker}
          showYearPicker={showYearPicker}
          showTimeSelect={withTime}
          timeFormat="HH:mm"
          maxDate={maxDate}
          minDate={minDate}
          // openToDate={!_.isEmpty(value) ? new Date(selected) : openToDate}
          popperPlacement={popperPlacement}
          selected={new Date(value || openToDate)}
          onChange={handleChangePicker}
        />
      </div>
    </div>
  );
}

DateInputPicker.defaultProps = {
  disabled: false,
  showMonthYearPicker: false,
  showYearPicker: false,
  withTime: false,
  isRequired: false,
  placeholder: '',
  maxDate: new Date('3000-01-01'),
  minDate: new Date('1900-01-01'),
  openToDate: new Date(),
  value: '',
  inputClassName: '',
  btnClassName: '',
  popperPlacement: 'bottom-right',
  name: '',
};

DateInputPicker.propTypes = {
  disabled: PropTypes.bool,
  showMonthYearPicker: PropTypes.bool,
  showYearPicker: PropTypes.bool,
  withTime: PropTypes.bool,
  isRequired: PropTypes.bool,
  placeholder: PropTypes.string,
  onChange: PropTypes.instanceOf(Function).isRequired,
  maxDate: PropTypes.instanceOf(Date),
  minDate: PropTypes.instanceOf(Date),
  openToDate: PropTypes.instanceOf(Date),
  value: PropTypes.string,
  inputClassName: PropTypes.string,
  btnClassName: PropTypes.string,
  popperPlacement: PropTypes.string,
  name: PropTypes.string,
};

const mapStateToProps = () => ({});

const enhance = _.flowRight([withRouter, connect(mapStateToProps)]);

export default enhance(DateInputPicker);
